import _merge from "lodash/merge";

import * as actionTypes from "../../actions/actionTypes";

const invitationReducer = (state = {}, action) => {
  const invitations = action?.response?.entities?.invitations;

  switch (action.type) {
    case actionTypes.FETCH_KIT_MEMBERS_SUCCESS:
    case actionTypes.INVITE_MEMBERS_SUCCESS:
    case actionTypes.FETCH_SPACE_INVITATIONS_SUCCESS:
    default: {
      if (invitations) {
        return _merge({}, state, invitations);
      }
      return state;
    }
  }
};

export default invitationReducer;
